import { useQueries } from '@tanstack/react-query';
import { fetchProduct } from './apiFetchProduct';
import { fetchRelatedBundles } from './apiFetchRelatedBundles';
import { GlobalReactQueryOptions } from '../../../../config';
import { browserClient } from '../../../../react-query';

const PRODUCT_QUERY_KEY = 'product';
const RELATED_BUNDLES_QUERY_KEY = 'relatedBundles';

export const useProduct = (productId: string, silentMode: boolean = false) => {
    const [product, relatedBundles] = useQueries({
        queries: [
            {
                queryKey: [PRODUCT_QUERY_KEY, productId],
                queryFn: () => fetchProduct(productId),
                ...GlobalReactQueryOptions
            },
            {
                queryKey: [RELATED_BUNDLES_QUERY_KEY, productId],
                queryFn: () => fetchRelatedBundles(productId),
                enabled: silentMode,
                ...GlobalReactQueryOptions
            }
        ]
    });

    return {
        isLoading: product.isLoading || relatedBundles.isLoading,
        data: {
            ...product.data,
            relatedBundlesByAuthor: relatedBundles?.data?.forAuthorIds,
            relatedBundlesByProduct: relatedBundles?.data?.forProductIds
        }
    };
};

export const invalidateProduct = (productId: string) => {
    return browserClient.invalidateQueries({ queryKey: [PRODUCT_QUERY_KEY, productId] });
};
